import React, { useContext, useRef, useState } from "react";
import { toFarsiNumber } from "../../helper/helper";
import { Link } from "react-router-dom";
import CircleLoading from "../shared/CircleLoading";
import { favouriteListContext } from "../../contexts/FavouriteContext";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { Toast } from "primereact/toast";
import { postData } from "../../services/API";

const AcademyCard = ({ data, click, setCourseInfo, courseInfo }) => {
  const [loading, setLoading] = useState(false);
  const [addedFav, setAddedFav] = useState(false);
  const { favouriteList, setFavouriteList } = useContext(favouriteListContext);
  const token = getItemStorage("token");
  const failLike = useRef(null);

  const setInfoHandler = () => {
    click && setCourseInfo(data);
  };

  // add or remove from favourite list
  const addFavourite = () => {
    if (token) {
      const favorite = favouriteList.filter((f) => f.id === data.id);

      // if product was in favorite list delete it otherwise add it
      if (favorite.length > 0) {
        setAddedFav(false);

        postData("/user/remove-from-favorite", { lesson_id: data.id })
          .then((res) => {
            const newData = favouriteList.filter((f) => f.id !== data.id);
            setAddedFav(false);

            setFavouriteList(newData);
          })
          .catch((err) => {
            setAddedFav(true);
          });
      } else {
        // add product to favourite list
        setAddedFav(true);

        postData("/user/add-to-favorite", { lesson_id: data.id })
          .then((res) => {
            setFavouriteList((prev) => [...prev, data]);
            setAddedFav(true);
          })
          .catch((err) => {
            setAddedFav(false);

            if (err.response.data.message === "Unauthenticated.") {
              failLike.current.show({
                severity: "error",
                summary: "وارد حساب کاربری کاربری شوید",
                detail: "برای افزودن به علاقه مندی وارد شوید",
                life: 2000,
              });
            }
          });
      }
    } else {
      failLike.current.show({
        severity: "error",
        summary: "وارد حساب کاربری کاربری شوید",
        detail: "برای افزودن به علاقه مندی وارد شوید",
        life: 2000,
      });
    }
  };

  return (
    <div
      onClick={setInfoHandler}
      className={`w-full h-auto flex flex-col gap-3 bg-[#222] ${
        click && data?.id === courseInfo?.id && "ring ring-yellow-700"
      } border border-gray-800 relative shadow-[0px_5px_25px_rgba(79,105,139,.09)] rounded-xl transition-all duration-300`}
    >
      <Toast ref={failLike} />

      {addedFav || favouriteList.filter((f) => f.id === data.id).length > 0 ? (
        <button
          onClick={addFavourite}
          className="py-2 px-2 rounded-lg absolute z-50 bg-red-600 transition-all duration-300 left-4 top-4 flex items-center gap-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4 fill-white transition-all duration-300"
          >
            <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
          </svg>
        </button>
      ) : (
        <button
          onClick={addFavourite}
          className="py-2 px-2 rounded-lg absolute z-50 bg-[#222] group hover:bg-red-600 transition-all duration-300 left-4 top-4 flex items-center gap-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4 stroke-red-600 group-hover:stroke-white transition-all duration-300"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
            />
          </svg>

          {/* <span className="text-red-600 group-hover:text-white text-xs transition-all duration-300">
            علاقه مندی
          </span> */}
        </button>
      )}

      {/* thumbnail */}
      <Link
        to={click ? "javascript:void(0)" : `/courses/${data.slug}`}
        className="overflow-hidden bg-gray-800 flex justify-center items-center min-h-[168px] rounded-xl"
      >
        {!loading && <CircleLoading />}

        <img
          src={`https://api.myunibest.ir/${data.h_image}`}
          alt={data.name}
          className={`w-full ${
            !loading && "!hidden"
          } object-cover hover:scale-110 transition-all duration-300 !h-[260px] sm:!h-[340px] md:!h-[210px] lg:!h-[169px] rounded-xl`}
          onLoad={() => setLoading(true)}
        />
      </Link>

      <div className="flex flex-col gap-4 px-3 pb-3">
        {/* categories */}
        <div className="flex items-center flex-wrap gap-2">
          {data?.categories?.length > 0 && (
            <span className="block bg-yellow-800 bg-opacity-10 rounded-lg px-2 py-1 text-yellow-600 text-sm">
              {data?.categories[0]?.category.name}
            </span>
          )}

          {data.has_sub ? (
            <span className="block bg-green-800 bg-opacity-10 rounded-lg px-2 py-1 text-green-600 text-sm">
              زیرنویس فارسی
            </span>
          ) : (
            ""
          )}

          {data.has_audio ? (
            <span className="block bg-red-800 bg-opacity-10 rounded-lg px-2 py-1 text-red-600 text-sm">
              دوبله
            </span>
          ) : (
            ""
          )}
        </div>

        {/* title */}
        <div className="flex justify-start items-center gap-2">
          <span className="block min-w-4 h-[6px] rounded-full bg-yellow-600"></span>
          <Link
            to={click ? "javascript:void(0)" : `/courses/${data.slug}`}
            className="text-gray-200 text-right text-[17px] line-clamp-1 font-bold"
          >
            {data.name}
          </Link>
          {/* <h1 className="text-gray-200 text-[17px] font-bold">آموزش ساخت ربات تلگرام با PHP</h1> */}
        </div>

        {/* description */}
        <p className="line-clamp-2 text-right h-[50px] min-h-fit text-sm leading-6 text-gray-400">
          {data.short_desc ? data.short_desc : "توضیحات کوتاه وارد نشده !"}
        </p>

        <div className="flex justify-between items-center pb-3 border-b border-gray-800">
          <div className="flex items-center gap-5">
            {/* author */}
            {/* <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-4 h-4 stroke-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                />
              </svg>

              <span className="text-sm text-gray-400">{data.teacher.name}</span>
            </div> */}

            {/* timer */}
            <div className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-4 h-4 stroke-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>

              <span className="text-sm text-gray-400">
                {data.duration ? toFarsiNumber(data.duration) : "ثبت نشده"}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-amber-400 text-[15px]">
              {data.rate ? toFarsiNumber(data.rate) : "امتیاز ندارد"}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-4 h-4 fill-amber-400"
            >
              <path
                fill-rule="evenodd"
                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>

        <div className="w-full flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 h-5 stroke-gray-400"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
              />
            </svg>

            <span className="text-gray-400 text-sm">
              {data.creator?.name ? data.creator.name : "ثبت نشده"}
            </span>
          </div>

          <Link
            to={click ? "javascript:void(0)" : `/courses/${data.slug}`}
            className="flex items-center gap-2"
          >
            <span className="text-yellow-600 text-sm">اطلاعات بیشتر</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-5 h-5 fill-yellow-700"
            >
              <path
                fill-rule="evenodd"
                d="M7.28 7.72a.75.75 0 0 1 0 1.06l-2.47 2.47H21a.75.75 0 0 1 0 1.5H4.81l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3.75-3.75a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AcademyCard;
